import C from "../constants";

export default function appReducer(subReducer) {
  return (state, action) => {
    switch (action.type) {
      case C.RESET_STATE:
        return {
          ...state,
          auth: action.payload.auth,
        };
      case C.LOGOUT_SUCCESS:
        return {
          ...state,
          auth: action.result.payload.auth,
        };
      case C.USER_CREATE_SUCCESS:
        const { user, invoicesList } = action.result;
        return {
          ...state,
          auth: {
            ...state.auth,
            user: {
              ...state.auth.user,
              invoicesList: invoicesList,
            },
          },
          users: {
            ...state.users,
            usersList: [...state.users.usersList, user].sort(
              (a, b) => a.created_at - b.created_at
            ),
            waitResponse: false,
            created: true,
          },
        };
      case C.DOCUMENT_CREATE:
        return {
          ...state,
          progress: {
            ...state.progress,
            meta: {},
          },
        };
      default:
        return subReducer(state, action);
    }
  };
}
